const OnEscape = function (ev) {
  if (ev.keyCode === 27) {
    this.addItem.modal.hide()
  }
}

export default OnEscape
